import { render, staticRenderFns } from "./MinePublish.vue?vue&type=template&id=b94ac4aa"
import script from "./MinePublish.vue?vue&type=script&lang=js"
export * from "./MinePublish.vue?vue&type=script&lang=js"
import style0 from "./MinePublish.vue?vue&type=style&index=0&id=b94ac4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports